// Constants
const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
  PASSWORD: {
    UPPERCASE_LOWERCASE: /(?=.*[A-Z])(?=.*[a-z])/,
    NUMBER: /\d/,
    SYMBOL: /[@\-!_#]/,
    MIN_LENGTH: 12,
  },
};

const ERROR_MESSAGES = {
  EMPTY_EMAIL: 'Insira seu e-mail e tente novamente',
  INVALID_EMAIL: 'Favor, informe um e-mail válido',
  EMPTY_PASSWORD: 'Insira sua senha e tente novamente',
  EMPTY_ACCESS_CODE: 'Insira sua chave de acesso e tente novamente',
  WRONG_CREDENTIALS: 'Senha ou chave de acesso incorretos, verifique e tente novamente',
  EMAIL_NOT_FOUND: 'Este e-mail não pertence a nenhum usuário cadastrado',
  TOO_MANY_REQUESTS: 'Você realizou requisições demais, tente novamente mais tarde',
  INCORRECT_TOKEN: 'Código incorreto, tente novamente',
  EXPIRED_TOKEN: 'Código expirado, solicite um novo',
  PASSWORDS_NOT_MATCH: 'Senhas não coincidem, tente novamente',
  PASSWORD_REQUIREMENTS: 'A senha não atende todos os requisitos acima',
  MFA_NOT_ENABLED: 'Múltiplo fator de autenticação não está habilitado no portal',
};

// DOM elements
const form = document.querySelector('form');
const header = document.querySelector('header');
const loginPage = document.querySelector('.login-page');
const togglePasswordButtons = document.querySelectorAll('.allos-input-eye');

const loginSection = document.querySelector('.login-page__container');

const emailInput = document.getElementById('input-email');
const passwordInput = document.getElementById('input-password');
const accessCodeInput = document.getElementById('input-access-code');

const submitButton = document.getElementById('submit-form');
const sendAccessCodeButton = document.getElementById('send-access-code');

const accessCodeError = document.getElementById('access-code-error');
const emailError = document.getElementById('email-error');
const passwordError = document.getElementById('password-error');
const forgotPasswordLink = document.getElementById('forgot-password');

const mfaStep1 = document.getElementById('mfa-step-1');
const mfaStep2 = document.getElementById('mfa-step-2');

const resetSection = document.querySelector('.login-page__reset-password');

const emailForm = document.getElementById('email-form');
const emailInputValidation = document.getElementById('input-email-validation');
const emailErrorValidation = document.getElementById('email-error-validation');
const sendResetButton = document.getElementById('send-reset');
const backToLoginButton = document.getElementById('back-to-login');

const tokenForm = document.getElementById('token-form');
const tokenInputValidation = document.getElementById('input-token-validation');
const tokenErrorValidation = document.getElementById('token-error-validation');
const resendTokenLink = document.getElementById('resend-token');
const sendTokenButton = document.getElementById('send-token');
const backToSendResetButton = document.getElementById('back-to-send-reset');

const newPasswordForm = document.getElementById('new-password-form');
const newPasswordInput = document.getElementById('input-new-password');
const newPasswordConfirmationInput = document.getElementById('input-confirm-new-password');
const newPasswordErrorValidation = document.getElementById('new-password-error-validation');
const confirmNewPasswordErrorValidation = document.getElementById(
  'confirm-new-password-error-validation'
);
const updatePasswordButton = document.getElementById('update-password');
const backToSendTokenLink = document.getElementById('back-to-send-token');

const successForm = document.getElementById('success-form');
const goToLoginButton = document.getElementById('go-to-login');

let emailForgotPassword = '';
let tokenForgotPassword = '';

// Utility Functions
function preventCopyPaste(event) {
  if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) {
    event.preventDefault();
  }
}

function mascararEmail(email) {
  const partes = email.split('@');
  const usuario = partes[0];
  const dominio = partes[1];

  const usuarioMascarado = usuario.substring(0, 3) + '*'.repeat(usuario.length - 3);
  const dominioMascarado = dominio.substring(0, 2) + '*'.repeat(dominio.length - 2);

  return usuarioMascarado + '@' + dominioMascarado;
}

function isValidEmail(email) {
  return VALIDATION_PATTERNS.EMAIL.test(email);
}

function allFieldsHaveValue(fields) {
  return fields.every(field => field.value !== '');
}

function showError(inputElement, errorElement, message) {
  inputElement.classList.add('error');
  errorElement.querySelector('.error-text').textContent = message;
  errorElement.style.display = 'flex';
}

function hideError(inputElement, errorElement) {
  inputElement.classList.remove('error');
  errorElement.style.display = 'none';
  errorElement.querySelector('.error-text').textContent = '';
}

function showFormSection(showSection, ...hideSections) {
  showSection.style.display = 'flex';
  hideSections.forEach(section => {
    section.style.display = 'none';
  });
}

function stopLoading(button) {
  button.classList.remove('button--loading');
}

function isValidPasswordForm() {
  const password = newPasswordInput.value;
  const confirmPassword = newPasswordConfirmationInput.value;

  if (!arePasswordRequirementsMet()) {
    showError(
      newPasswordConfirmationInput,
      confirmNewPasswordErrorValidation,
      ERROR_MESSAGES.PASSWORD_REQUIREMENTS
    );

    return false;
  }

  hideError(newPasswordConfirmationInput, confirmNewPasswordErrorValidation);

  if (password !== confirmPassword) {
    showError(
      newPasswordConfirmationInput,
      confirmNewPasswordErrorValidation,
      ERROR_MESSAGES.PASSWORDS_NOT_MATCH
    );

    return false;
  }

  return true;
}

// Initialize copy/paste prevention
document.getElementById('input-confirm-new-password').addEventListener('keydown', preventCopyPaste);

// Form field validation configs
const configurations = [
  {
    button: sendResetButton,
    inputs: [emailInputValidation],
  },
  {
    button: sendTokenButton,
    inputs: [tokenInputValidation],
  },
  {
    button: updatePasswordButton,
    inputs: [newPasswordInput, newPasswordConfirmationInput],
  },
];

configurations.forEach(config => {
  config.inputs.forEach(input => {
    input.addEventListener('input', () => {
      config.button.disabled = !allFieldsHaveValue(config.inputs);
    });
  });
});

// API functions
async function obterUrlRedirecionamento() {
  try {
    const redirectResponse = await fetch('/api/loginAdministracao/solicitaUrlRedirecionamento', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (redirectResponse.status === 200) {
      return redirectResponse.url;
    } else {
      console.error('Erro ao obter a URL de redirecionamento do servidor');

      return null;
    }
  } catch (error) {
    console.error('Ocorreu um erro ao obter a URL de redirecionamento: ', error);

    return null;
  }
}

async function sendMFAToken(username) {
  try {
    const emailValue = username.trim();

    if (!emailValue) {
      showError(emailInput, emailError, ERROR_MESSAGES.EMPTY_EMAIL);

      return;
    }

    hideError(emailInput, emailError);

    const response = await fetch(
      `/lumis/api/rest/lumis/authentication/sendMFATokenEmail/${emailValue}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.status === 204) {
      showFormSection(mfaStep2, mfaStep1);
    } else if (response.status === 409) {
      showError(emailInput, emailError, ERROR_MESSAGES.MFA_NOT_ENABLED);
    } else if (response.status === 404) {
      showError(emailInput, emailError, ERROR_MESSAGES.EMAIL_NOT_FOUND);
    }
  } catch (error) {
    console.error('Erro ao enviar código de acesso:', error);
  } finally {
    stopLoading(sendAccessCodeButton);
  }
}

async function realizaLogin(username, password, mfaToken) {
  try {
    const emailValue = username.trim();
    const passwordValue = password.trim();
    const accessCodeValue = mfaToken.trim();

    let hasError = false;

    if (!passwordValue) {
      showError(passwordInput, passwordError, ERROR_MESSAGES.EMPTY_PASSWORD);

      hasError = true;
    } else {
      hideError(passwordInput, passwordError);
    }

    if (!accessCodeValue) {
      showError(accessCodeInput, accessCodeError, ERROR_MESSAGES.EMPTY_ACCESS_CODE);

      hasError = true;
    } else {
      hideError(accessCodeInput, accessCodeError);
    }

    if (hasError) {
      return;
    }

    const formData = new URLSearchParams();

    formData.append('username', emailValue);
    formData.append('password', passwordValue);
    formData.append('mfaToken', accessCodeValue);

    const response = await fetch('/lumis/api/rest/lumlogin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
    });

    if (response.status === 204) {
      const redirectUrl = await obterUrlRedirecionamento();

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        console.error(
          'A resposta não contém um cabeçalho de Location ou a URL de redirecionamento não está disponível.'
        );
      }
    } else if (response.status === 403) {
      showError(passwordInput, passwordError, ERROR_MESSAGES.WRONG_CREDENTIALS);
    } else if (response.status === 400) {
      console.error('Usuário não fornecido na requisição');
    } else {
      console.error('Erro inesperado durante o processamento da requisição');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  } finally {
    stopLoading(submitButton);
  }
}

async function solicitarAlteracaoSenha(email) {
  try {
    if (!isValidEmail(email)) {
      showError(emailInputValidation, emailErrorValidation, ERROR_MESSAGES.INVALID_EMAIL);
      stopLoading(sendResetButton);

      return;
    }

    const response = await fetch('/api/loginAdministracao/solicitaAlteracaoSenha', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    if (response.status === 200) {
      setTimeout(() => {
        stopLoading(sendResetButton);
        showFormSection(tokenForm, emailForm);
      }, 1000);

      emailForgotPassword = email;

      const emailMascarado = mascararEmail(emailForgotPassword);

      document.getElementById('token-form').querySelector('p > b').textContent = emailMascarado;
    } else if (response.status === 403) {
      showError(emailInputValidation, emailErrorValidation, ERROR_MESSAGES.TOO_MANY_REQUESTS);
      stopLoading(sendResetButton);
    } else {
      console.error('Ocorreu um erro durante a solicitação de alteração de senha.');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

async function validaToken(email, token) {
  try {
    const response = await fetch(
      `/api/loginAdministracao/validaToken?email=${email}&token=${token}`
    );

    if (response.status === 200) {
      const isValid = await response.text();

      if (isValid === 'true') {
        tokenForgotPassword = token;

        setTimeout(() => {
          stopLoading(sendTokenButton);
          showFormSection(newPasswordForm, tokenForm);
        }, 1000);
      } else if (isValid === 'false') {
        showError(tokenInputValidation, tokenErrorValidation, ERROR_MESSAGES.INCORRECT_TOKEN);
        stopLoading(sendTokenButton);
      }
    } else if (response.status === 403) {
      const responseText = await response.text();
      const isExpired = responseText === 'Token Expirado';

      if (isExpired) {
        showError(tokenInputValidation, tokenErrorValidation, ERROR_MESSAGES.EXPIRED_TOKEN);
        stopLoading(sendTokenButton);
      } else {
        console.error('O email não corresponde a nenhum usuário.');
      }
    } else {
      console.error('Ocorreu um erro durante a validação do token.');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

async function alterarSenha(email, token, novaSenha) {
  try {
    const response = await fetch('/api/loginAdministracao/alteraSenha', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, token, novaSenha }),
    });

    if (response.status === 200) {
      setTimeout(() => {
        stopLoading(updatePasswordButton);
        showFormSection(successForm, newPasswordForm);
      }, 1000);
    } else if (response.status === 403) {
      console.error('Usuário/token incorreto.');
    } else if (response.status === 409) {
      console.error('A senha não corresponde às especificações mínimas de segurança.');
    } else {
      console.error('Ocorreu um erro durante a alteração de senha.');
    }
  } catch (error) {
    console.error('Ocorreu um erro inesperado: ', error);
  }
}

function adjustHeaderVisibility() {
  if (getComputedStyle(loginSection).display === 'none') {
    header.style.display = 'flex';
    loginPage.classList.add('reset-password--active');
  } else {
    header.style.display = 'none';
    loginPage.classList.remove('reset-password--active');
  }
}

// Initial setup
adjustHeaderVisibility();

// Password toggle functionality
togglePasswordButtons.forEach(button => {
  button.addEventListener('click', () => {
    const associatedInput = document.getElementById(button.dataset.inputId);

    if (associatedInput) {
      const currentType = associatedInput.getAttribute('type');
      const newType = currentType === 'password' ? 'text' : 'password';
      associatedInput.setAttribute('type', newType);
      button.classList.toggle('bi-eye');
    }
  });
});

// Form event handlers
form.addEventListener('submit', e => {
  e.preventDefault();
});

sendAccessCodeButton.addEventListener('click', e => {
  e.preventDefault();
  sendAccessCodeButton.classList.add('button--loading');

  sendMFAToken(emailInput.value);
});

submitButton.addEventListener('click', e => {
  e.preventDefault();
  submitButton.classList.add('button--loading');

  realizaLogin(emailInput.value, passwordInput.value, accessCodeInput.value);
});

// Password reset flow
forgotPasswordLink.addEventListener('click', e => {
  e.preventDefault();
  showFormSection(resetSection, loginSection);
  adjustHeaderVisibility();
});

backToSendResetButton.addEventListener('click', e => {
  e.preventDefault();
  showFormSection(emailForm, tokenForm);
});

backToSendTokenLink.addEventListener('click', e => {
  e.preventDefault();
  showFormSection(tokenForm, newPasswordForm);
});

goToLoginButton.addEventListener('click', e => {
  e.preventDefault();

  document
    .querySelectorAll('input[type="text"], input[type="email"], input[type="password"]')
    .forEach(input => {
      input.value = '';
    });

  newPasswordErrorValidation.querySelectorAll('li').forEach(rule => {
    rule.classList.remove('valid');
    rule.querySelector('.bi').classList.remove('bi-check2');
    rule.querySelector('.bi').classList.add('bi-dot');
  });

  showFormSection(loginSection, resetSection, successForm);
  showFormSection(emailForm, tokenForm, newPasswordForm);
  adjustHeaderVisibility();
});

backToLoginButton.addEventListener('click', e => {
  e.preventDefault();
  showFormSection(loginSection, resetSection);
  adjustHeaderVisibility();

  hideError(emailInputValidation, emailErrorValidation);
  emailInputValidation.value = '';
});

sendResetButton.addEventListener('click', e => {
  e.preventDefault();
  sendResetButton.classList.add('button--loading');

  hideError(emailInputValidation, emailErrorValidation);
  solicitarAlteracaoSenha(emailInputValidation.value);
});

resendTokenLink.addEventListener('click', e => {
  solicitarAlteracaoSenha(emailForgotPassword);
});

sendTokenButton.addEventListener('click', e => {
  e.preventDefault();
  sendTokenButton.classList.add('button--loading');

  hideError(tokenInputValidation, tokenErrorValidation);
  validaToken(emailForgotPassword, tokenInputValidation.value);
});

// New password validation
function validateOnInput() {
  const password = newPasswordInput.value;

  toggleValidationClassOnInput(
    document.getElementById('rule-uppercase-lowercase'),
    VALIDATION_PATTERNS.PASSWORD.UPPERCASE_LOWERCASE.test(password)
  );
  toggleValidationClassOnInput(
    document.getElementById('rule-number'),
    VALIDATION_PATTERNS.PASSWORD.NUMBER.test(password)
  );
  toggleValidationClassOnInput(
    document.getElementById('rule-symbol'),
    VALIDATION_PATTERNS.PASSWORD.SYMBOL.test(password)
  );
  toggleValidationClassOnInput(
    document.getElementById('rule-length'),
    password.length >= VALIDATION_PATTERNS.PASSWORD.MIN_LENGTH
  );
}

function validateOnBlur() {
  const password = newPasswordInput.value;

  toggleValidationClassOnBlur(
    document.getElementById('rule-uppercase-lowercase'),
    VALIDATION_PATTERNS.PASSWORD.UPPERCASE_LOWERCASE.test(password)
  );
  toggleValidationClassOnBlur(
    document.getElementById('rule-number'),
    VALIDATION_PATTERNS.PASSWORD.NUMBER.test(password)
  );
  toggleValidationClassOnBlur(
    document.getElementById('rule-symbol'),
    VALIDATION_PATTERNS.PASSWORD.SYMBOL.test(password)
  );
  toggleValidationClassOnBlur(
    document.getElementById('rule-length'),
    password.length >= VALIDATION_PATTERNS.PASSWORD.MIN_LENGTH
  );
}

function toggleValidationClassOnInput(element, isValid) {
  const icon = element.querySelector('.bi');
  if (isValid) {
    element.classList.add('valid');
    element.classList.remove('invalid');
    icon.classList.remove('bi-exclamation-circle');
    icon.classList.remove('bi-dot');
    icon.classList.add('bi-check2');
  } else {
    icon.classList.remove('bi-check2');
    icon.classList.add('bi-dot');
    element.classList.remove('valid');
  }
}

function toggleValidationClassOnBlur(element, isValid) {
  const icon = element.querySelector('.bi');
  if (!isValid) {
    element.classList.add('invalid');
    icon.classList.remove('bi-check2');
    icon.classList.add('bi-exclamation-circle');
  } else {
    element.classList.remove('invalid');
    icon.classList.remove('bi-exclamation-circle');
    icon.classList.add('bi-check2');
  }
}

function arePasswordRequirementsMet() {
  const password = newPasswordInput.value;

  return (
    VALIDATION_PATTERNS.PASSWORD.UPPERCASE_LOWERCASE.test(password) &&
    VALIDATION_PATTERNS.PASSWORD.NUMBER.test(password) &&
    VALIDATION_PATTERNS.PASSWORD.SYMBOL.test(password) &&
    password.length >= VALIDATION_PATTERNS.PASSWORD.MIN_LENGTH
  );
}

newPasswordInput.addEventListener('input', validateOnInput);
newPasswordInput.addEventListener('blur', validateOnBlur);

updatePasswordButton.addEventListener('click', e => {
  e.preventDefault();
  updatePasswordButton.classList.add('button--loading');

  if (!isValidPasswordForm()) {
    stopLoading(updatePasswordButton);

    return;
  }

  alterarSenha(emailForgotPassword, tokenForgotPassword, newPasswordConfirmationInput.value);
});
